import React, {useEffect, useMemo, useState} from 'react';
import {useLoader} from "@quadral/quadral-component-common/dist/components/loader/LoaderContext";
import QuadralBigNumber from '@quadral/quadral-component-common/dist/components/bigNumber'
import QuadralContainer from '@quadral/quadral-component-common/dist/components/container'
import QuadralCard from '@quadral/quadral-component-common/dist/components/card'
import QuadralTimeline from "@quadral/quadral-component-common/dist/components/timeline";
import QuadralButtonIcon from "@quadral/quadral-component-common/dist/components/buttonIcon";
import QuadralBadge from "@quadral/quadral-component-common/dist/components/badge"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAt, faClockRotateLeft, faEuroSign, faEye, faFileLines, faPen, faPeopleGroup, faUser} from '@fortawesome/free-solid-svg-icons';
import QuadralTypography from '@quadral/quadral-component-common/dist/components/typography'
import Grid from '@mui/material/Grid';
import UpdatePersonModal from './UpdatePersonModal';
import Chip from '@mui/material/Chip';


const Details = ({getDocStatusCount, roles, mapReferences, participation, signatoryPerson, persons, activityRecords, formatDate, getTypeColor, getTypeIcon, ...props}) => {

    const {showLoader, hideLoader} = useLoader();
    const[timeline, setTimeline] = useState([]);
    const [selectedPerson, setSelectedPerson] = useState([])
    const [open, setOpen] = useState(false);

    const motiveOptions= useMemo(() => [
        {   label: "-- Sélectionner un motif --",    value: "selectmotive", },
        {   label: "Global - Compréhension de l'enquête ou d'une relance",    value: "Global_Comprehension_de_l_enquete_ou_d_une_relance", },
        {   label: "Global - Le client ne dispose pas d'une pièce que nous lui avons demandé",    value: "Global_Le_client_ne_dispose_pas_d_une_piece_que_nous_lui_avons_demande", },
        {   label: "Global - Souhait de confirmer bonne réception du dossier",    value: "Global_Souhait_de_confirmer_bonne_reception_du_dossier", },
        {   label: "Papier - Usage - Accompagnement renseignement formulaire",    value: "Papier_Usage_Accompagnement_renseignement_formulaire", },
        {   label: "Télédéclaration - Usage - Accompagnement parcours en ligne (accès/saisie/validation)",    value: "Teledeclaration_Usage_Accompagnement_parcours_en_ligne", },
        {   label: "Télédéclaration - Usage - Souhait de réponse au format papier",      value: "Teledeclaration_Usage_Souhait_de_reponse_au_format_papier"     },
        {   label: "Télédéclaration - Usage - Téléchargement des pièces",      value: "Teledeclaration_Usage_Telechargement_des_pieces"     },
        {   label: "Télédéclaration - Problème technique",      value: "Teledeclaration_Probleme_technique"     },
        {   label: "Divers - Autres motifs",      value: "Divers_Autres_motifs"     },
    ], []);

    const personsSynthetic=[
        {
            label:  'Nom et prénom',
            value:  `${participation?.firstname} ${participation?.lastname}`,
        },
        {
            label:  'Date de naissance',
            value:  `${getFormatDate(signatoryPerson?.birthDate)}`,
        },
        {
            label:  'Nationalité',
            value:  `${signatoryPerson?.nationalityPerCategory}`,
        },
        {
            label:  'Téléphone mobile',
            value:  `${signatoryPerson?.phoneNumber}`,
        },
        {
            label:  'Email',
            value:  `${signatoryPerson?.email}`,
        },
        {
            label:  'Canal',
            value: (() => {
                const channel = participation?.communicationChannel;
                if (!channel) return null;

                const icon = {
                    email: faAt,
                    papier: faFileLines,
                }[channel];

                return (
                    <QuadralBadge
                        label={channel}
                        color="secondary"
                        style={{color:'#000', textTransform: 'capitalize'}}
                        icon={<FontAwesomeIcon icon={icon}/>}
                    />
                );
            })(),
        },
        {
            label:  'Téléphone domicile',
            value:  `${signatoryPerson?.homePhoneNumber}`,
        },
        {
            label:  'Adresse',
            value:  `${participation?.assetAddressNumber} ${participation?.assetAddressStreet}, ${participation?.assetAddressCity} ${participation?.assetAddressPostcode}`,
        },
        {
            label:  'Code contrat',
            value:  <Chip
                        label={participation?.contractCode}
                        variant="filled"
                        sx={{
                            bgcolor: "#EEF2FF",
                            color: "text.primary",
                            borderRadius: "10px",
                            fontWeight: 500,
                            fontSize: 14,
                            height: 40,
                        }}
                    />,
        },
    ]

    const rfrSynthetic = [
        //TODO Rétablir en V2.0
        // {
        //     label: 'Total des revenus mensuels déclarés',
        //     value: 'ADD_VALUE_HERE',
        // },
        // {
        //     label: 'Total des prestations déclarées',
        //     value: 'ADD_VALUE_HERE',
        // },
        {
            label: 'RFR total',
            value:  participation?.totalRFR != null
                    ? `${participation.totalRFR.toLocaleString('fr-FR')} €`
                    : ''
        },
    ];

    function getFormatDate(rawDate){
        if(!rawDate) return "inconnu";
        const date = new Date(rawDate);
        const day = String(date.getDate()).padStart(2,'0');
        const month = date.toLocaleString('fr-FR', {month: 'long'});
        const year = date.getFullYear();
        return day + " " + month + " " + year;
    }

    function calculateAge(birthDateString) {
        const birthDate = new Date(birthDateString);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();

        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }

        return age;
    }

    function extractContentAndAuthor(text) {
        if(!text) return ["", ""];

        const separator = "par l’utilisateur";
        const index = text.toLowerCase().lastIndexOf(separator.toLowerCase());

        if (index === -1) {
            return [text.trim(), ""];
        }

        const message = text.slice(0, index).trim();

        let author = text
            .slice(index + separator.length)
            .trim();

        if (!author || author.toLowerCase() === "null") {
            author = "";
        }

        return [message, author];
    }

    useEffect(() => {
        const newTimeline = (activityRecords?.activities || []).slice(0, 3).map((element) => ({
            title: element.subject
                ? (motiveOptions.find(opt => opt.value === element.subject)?.label || element.subject)
                : "Non renseigné",
            content: extractContentAndAuthor(element.description)[0],
            time: element.creationDate ? (() => {
                const [date, time] = element.creationDate.split("T");
                const timeFormatted = time.substring(0, 5);
                return `${formatDate(date)} - ${timeFormatted}`;
            })() : "inconnu",
            origin: element.description ? (() => {
                const user = extractContentAndAuthor(element.description)[1];
                return user ? user : null;
            })() : null,
            icon: <FontAwesomeIcon icon={getTypeIcon(element.type)} />,
            iconColor: getTypeColor(element.type),
        }))

        setTimeline(newTimeline);
    }, [activityRecords, motiveOptions, formatDate, getTypeIcon, getTypeColor]);

    return(<>
        <QuadralContainer orientation='row' sx={{gap: '32px', paddingBottom: '1rem'}}>
            <QuadralBigNumber
                title='Bailleur'
                value={props?.bailleur}
            />
            <QuadralBigNumber
                title='Pièces à vérifier'
                value={getDocStatusCount("attente_verification")}
                color='info'
                actionArea
                onClick={() => {
                    props.setTabValue("4")
                }}
            />
            <QuadralBigNumber
                title='Pièces à fournir'
                value={getDocStatusCount("a_fournir")}
                color='error'
                actionArea
                onClick={() => {
                    props.setTabValue("4")
                }}
            />
        </QuadralContainer>
        <Grid container spacing="15px">
            <Grid size={{ xs: 12, sm: 6 }}>
                <QuadralCard
                    title='Informations du signataire principal'
                    icon={<FontAwesomeIcon icon={faUser}/>}
                    sx={{ width: '100%', height: 'stretch !important' }}
                    action={
                        <QuadralButtonIcon 
                            icon={ <FontAwesomeIcon style={{fontSize:'1rem'}} icon={faPen}/> }
                            onClick={() => {
                                setSelectedPerson(signatoryPerson);
                                setOpen(true);
                            }}
                        />
                    }
                >
                    <Grid container spacing="15px">
                        {personsSynthetic.map((item) => (
                            <Grid sx={{padding: '0.5rem 1rem', display:'flex', flexDirection:'column'}} size={{md: 4, sm: 12, xs: 12}}>
                                <QuadralTypography variant='dataLabel'>{item.label}</QuadralTypography>
                                {(item.value && item.value !== 'undefined' && item.value !== 'inconnu') ? (
                                    <QuadralTypography sx={{wordBreak: 'break-word'}}variant='dataValue'>{item.value || ' '}</QuadralTypography>
                                ) : (
                                    <QuadralTypography sx={{wordBreak: 'break-word', textTransform:'none'}}variant='dataLabel'>Non renseigné</QuadralTypography>
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </QuadralCard>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <QuadralCard
                    title='Revenus et prestations'
                    icon={<FontAwesomeIcon icon={faEuroSign}/>}
                    sx={{ width: '100%', height: 'stretch !important' }}
                    action={ 
                        <QuadralButtonIcon 
                            icon={<FontAwesomeIcon style={{fontSize:'1rem'}} icon={faEye}/>}
                            onClick={() => {
                                props.setTabValue("3")
                            }}/>}
                >
                    <QuadralContainer orientation='column'>
                        {rfrSynthetic.map((item) => (
                            <QuadralContainer sx={{padding: '0.5rem 1rem', display:'flex', flexDirection:'row', justifyContent: 'space-between'}} size={{md: 3, sm: 4, xs: 12}}>
                                <QuadralTypography variant='dataValue'>{item.label}</QuadralTypography>
                                <QuadralTypography sx={{wordBreak: 'break-word'}}variant='dataValue'>{item.value || ' '}</QuadralTypography>
                            </QuadralContainer>
                        ))}
                        
                    </QuadralContainer>
                </QuadralCard>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <QuadralCard
                    title='Personnes'
                    icon={<FontAwesomeIcon icon={faPeopleGroup}/>}
                    sx={{ width: '100%', height: 'stretch !important' }}
                    action={ 
                        <QuadralButtonIcon 
                            icon={<FontAwesomeIcon style={{fontSize:'1rem'}} icon={faEye}/>}
                            onClick={() => {
                                props.setTabValue("2")
                            }}/> }
                >
                    <Grid container spacing="15px">
                        {persons.map((person) => {
                            return(<>
                            <Grid sx={{display:'flex', flexDirection:'column'}} size={{md: 6, sm: 6, xs: 12}}>
                                <QuadralCard 
                                    title={`${person.lastname} ${person.firstname}`} 
                                    variant='small' 
                                    sx={{
                                        minWidth: 'auto',
                                        width: '100%',
                                        height: 'stretch !important',
                                    }}
                                    action={
                                        <QuadralButtonIcon 
                                            icon={ <FontAwesomeIcon style={{fontSize: '0.8rem'}} icon={faPen}/> }
                                            onClick={() => {
                                                setSelectedPerson(person);
                                                setOpen(true);
                                        }} />
                                    }
                                >
                                    {
                                        [
                                            person.occupantType != null &&
                                                mapReferences(person.occupantType, 'PERSON_RECORD_OCCUPANT_TYPE'),

                                            person.birthDate != null &&
                                                calculateAge(person.birthDate),

                                            person.familySituation != null &&
                                                mapReferences(person.familySituation, 'PERSON_RECORD_FAMILY_SITUATION'),

                                            person.householdLink != null &&
                                                mapReferences(person.householdLink, 'PERSON_RECORD_HOUSE_HOLD_LINK'),
                                        ].filter(Boolean).join(' / ')
                                    }
                                </QuadralCard>
                            </Grid>
                        </>)})}
                    </Grid>
                </QuadralCard>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <QuadralCard
                    title='Activités'
                    icon={<FontAwesomeIcon icon={faClockRotateLeft}/>}
                    sx={{ width: '100%', height: 'stretch !important' }}
                    action={ 
                        <QuadralButtonIcon 
                            icon={<FontAwesomeIcon style={{fontSize:'1rem'}} icon={faEye}/>}
                            onClick={() => {
                                props.setTabValue("5")
                            }}/>}
                >
                    <QuadralContainer orientation='column'>
                        <QuadralTimeline numberOfRows={4} timelineLength={3} timeline={timeline} sx={{padding: 0 , margin: 0, marginLeft: '-0.375rem'}} cardStyle={{padding: '1rem'}}/>
                    </QuadralContainer>
                </QuadralCard>
            </Grid>
        </Grid>
        <UpdatePersonModal
            selectedPerson={selectedPerson}
            open={open}
            setOpen={setOpen}
            showLoader={showLoader}
            hideLoader={hideLoader}
            participation={participation}
            mapReferenceToOptions={props.mapReferenceToOptions}
            refreshPersonsData={props.refreshPersonsData}
            quadralToast={props.quadralToast}
        />
    </>);
};

export default Details;
